import Mention from '@tiptap/extension-mention';

/**
 * Custom Mention extension that adds userType and organizationId attributes
 * This allows us to store the user type (job_seeker/employer) and organization_id in the mention
 * so we can navigate to the correct profile page when clicked
 */
export const CustomMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      userType: {
        default: null,
        parseHTML: element => element.getAttribute('data-user-type'),
        renderHTML: attributes => {
          if (!attributes.userType) {
            return {};
          }
          return {
            'data-user-type': attributes.userType,
          };
        },
      },
      organizationId: {
        default: null,
        parseHTML: element => element.getAttribute('data-organization-id'),
        renderHTML: attributes => {
          if (!attributes.organizationId) {
            return {};
          }
          return {
            'data-organization-id': attributes.organizationId,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setMention: (attributes: any) => ({ commands }: any) => {
        return commands.insertContent({
          type: this.name,
          attrs: {
            id: attributes.id,
            label: attributes.label,
            userType: attributes.userType || null,
            organizationId: attributes.organizationId || null,
          },
        });
      },
    } as any;
  },
});
